import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Settings, SettingsPayload } from 'src/app/models/settings.model';
import { environment } from 'src/environments/environment';
import { EventStateService } from '../state-service/event-state.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(
    private http: HttpClient,
    private eventStateService: EventStateService
  ) {}

  getSettings(dataset: string): Observable<Map<string, Settings>> {
    this.eventStateService.isSettingsLoading = true;
    return this.http
      .get<Settings[]>(`${environment.CRD_API}v2/settings/?dataset=${dataset}`)
      .pipe(this.mapSettingsArrayToMap());
  }

  saveSettings(payload: SettingsPayload): Observable<Map<string, Settings>> {
    return this.http
      .post<Settings[]>(`${environment.CRD_API}v2/settings/`, payload)
      .pipe(this.mapSettingsArrayToMap());
  }

  private mapSettingsArrayToMap() {
    return map(
      (settingsArray: Settings[]) =>
        new Map(settingsArray.map((item) => [item.settings_key, item]))
    );
  }
}
